var map = {
	"./events-cat.webp": 2092,
	"./games-cat.webp": 2093,
	"./live-casino-cat.webp": 2094,
	"./lottery-cat.webp": 2095,
	"./other-cat.webp": 2096,
	"./p2p-cat.webp": 2097,
	"./pd-table.webp": 2098,
	"./privacy-policy-title-bm.webp": 2099,
	"./privacy-policy-title-cn.webp": 2100,
	"./privacy-policy-title-id.webp": 2101,
	"./privacy-policy-title.webp": 2102,
	"./promos-1.webp": 2103,
	"./promos-2.webp": 2104,
	"./promos-3.webp": 2105,
	"./promos-4.webp": 2106,
	"./question.webp": 2107,
	"./sideBar-bg.webp": 2108,
	"./slot-cat.webp": 2109,
	"./special-cat.webp": 2110,
	"./sports-cat.webp": 2111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 461;